import { createContext } from 'react'
import type { Session, User } from '@supabase/supabase-js'

// Split out of AuthProvider.tsx (FE-31-11 react-refresh/only-export-components):
// fast-refresh requires a component file to export only components, so the
// React context + its value type live here in a JSX-free module. AuthProvider
// imports them; useAuth keeps consuming AuthContext. No auth logic changes.
// Admin/owner role for the current user. `null` = regular user OR not yet
// resolved (use `roleLoading` to distinguish). owner ⊃ admin: an owner is also
// an admin; the label just refines which one. This is a UX hint only — the real
// access boundary is server-side (RLS + SECURITY DEFINER RPCs), never this flag.
export type AdminRole = 'owner' | 'admin' | null

export interface AuthContextValue {
  session: Session | null
  user: User | null
  loading: boolean
  role: AdminRole
  roleLoading: boolean
  signInWithMagicLink: (email: string, options?: { next?: string; name?: string; marketingOptIn?: boolean }) => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
